
import { createFileRoute } from '@tanstack/react-router';
import { useMember, mayCreateResource } from '@/lib/use-session';
import { ResourcesListBody } from '@/components/resources/ResourcesListBody';
import { type ResourcesSearchInput } from '@/lib/queries/resources';
import { useOnboardingVisitPing } from '@/lib/onboarding/useVisitPing';

function pickStr(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}
function pickStrArr(v: unknown): string[] | undefined {
  if (Array.isArray(v)) {
    const arr = v.filter((s) => typeof s === 'string') as string[];
    return arr.length > 0 ? arr : undefined;
  }
  if (typeof v === 'string' && v.length > 0) return [v];
  return undefined;
}

export const Route = createFileRoute('/_public/resources/')({
  validateSearch: (raw: Record<string, unknown>): ResourcesSearchInput => ({
    ...(pickStr(raw.q) ? { q: pickStr(raw.q) as string } : {}),
    ...(pickStr(raw.scope) ? { scope: pickStr(raw.scope) as string } : {}),
    ...(pickStr(raw.kind) ? { kind: pickStr(raw.kind) as string } : {}),
    ...(pickStrArr(raw.tags) ? { tags: pickStrArr(raw.tags) as string[] } : {}),
    ...(pickStr(raw.sort) ? { sort: pickStr(raw.sort) as string } : {}),
  }),
  component: ResourcesPage,
});

function ResourcesPage() {
  const me = useMember();
  const signedIn = me !== null;
  const canAuthor = me !== null && mayCreateResource(me.platformRole);
  useOnboardingVisitPing(['visit_resources', 'attend_training'], signedIn);
  return <ResourcesListBody canAuthor={canAuthor} signedIn={signedIn} />;
}
